import {hasRole} from './hasRole';

const prefixes = ['ROLE_MATERIAL', 'ROLE_MATERIAL_PRODUCTION', 'ROLE_MATERIAL_TRADING', 'ROLE_MATERIAL_OPERATIONS'];

// Material CRUD and imports accept any of these role families on the backend.
export const materialPermissions = (storedRoles = localStorage.getItem('roles')) => {
  const write = prefixes.some(prefix => hasRole(`${prefix}_WRITE`, storedRoles));
  const read = prefixes.some(prefix => hasRole(`${prefix}_READ`, storedRoles));
  return {write, read, readMaterials: read || write || hasRole('ROLE_OFFER_READ', storedRoles)};
};
